@use "diy_base.module.scss";
@use "error_message.module.scss";
@use "foundation/colors";
@use "foundation/mixins";
@use "foundation/responsive";
@use "foundation/typography";

.ai-maker-section {
  display: flex;
  flex-direction: column;

  width: diy_base.$box-width;
  margin: 0 auto;

  @include responsive.phone {
    width: diy_base.$box-width-phone;
  }

  div.input-area {
    width: 100%;

    p.tips {
      font-size: 16px;
      margin-top: 0;
      color: colors.$neutrals-dark-grey;
      text-align: center;
      font-weight: 600;

      a {
        color: colors.$neutrals-dark-grey;
        font-weight: 700;
        text-decoration: underline;
        margin-left: 4px;
      }
    }

    .textarea-wrapper {
      position: relative;
    }

    textarea {
      @include mixins.placeholder(colors.$neutrals-grey);

      resize: none;
      font-size: mixins.em(32px);
      border: solid 4px colors.$neutrals-light-grey !important;

      &.with-errors {
        border-color: colors.$secondary-tomato !important;
      }

      &:active:not(:disabled),
      &:focus:not(:disabled) {
        color: colors.$primary-eerie-black;
        border-color: colors.$primary-eerie-black !important;
      }

      @include responsive.phone {
        font-size: mixins.em(28px);
      }
      @include responsive.small-phone {
        font-size: 18px;
      }
    }

    .hint-helper {
      display: flex;
      align-items: center;
      min-height: mixins.em(50px);
      margin-top: mixins.em(4px);
      margin-bottom: mixins.em(32px);
    }

    .example-spacer {
      margin-bottom: mixins.em(32px);
    }
  }

  /* hack to have error_message style reused. */
  .error-message {
    background-color: colors.$secondary-tomato;
    margin-top: 0;
    margin-bottom: 0;
    padding: mixins.em(8px) mixins.em(16px);
    font-size: 16px;
  }

  .examples {
    p {
      font-weight: 700;
      margin-top: 0;
    }

    ul {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 16px;
      margin-bottom: mixins.em(64px);

      @include responsive.phone {
        grid-template-columns: repeat(1, 1fr);
        grid-column-gap: 0;
        grid-row-gap: 16px;
        margin-bottom: mixins.em(128px);
      }

      li {
        button {
          height: 100%;
          text-align: left;
          font-size: mixins.em(16px);
          font-weight: 600;
          line-height: 1.5em;
          cursor: pointer;
          background-color: #eee;
          color: #666;
          padding: 1em;
          border-radius: 10px;
        }
      }
    }
  }

  div.controls {
    position: relative;
    text-align: center;
    min-height: 100px;

    @include responsive.small-phone {
      button {
        width: 100%;
      }
    }

    .upgrade-copy {
      display: flex;
      align-items: center;
      font-size: 28px;

      @include responsive.small-phone {
        font-size: 22px;
      }

      > *:first-child {
        margin-right: mixins.em(10px);
      }

      .badge {
        display: flex;
        width: mixins.em(64px);

        svg {
          height: 60px;

          @include responsive.small-phone {
            height: 48px;
          }

          path {
            fill: colors.$primary-white;
          }
        }
      }
    }

    @include responsive.small-phone {
      span.loading {
        font-size: 18px;
      }

    }
  }

  .loading-dots {
    height: 1.75em;
    margin-left: mixins.em(2px);
  }
}
